import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import authAPI from "../../../services/authApi";
import { getApiErrorMessage } from "../../../utils/apiError";
import PlatformAuthShell from "../../Clinic/Auth/PlatformAuthShell";
import AuthField from "../../Clinic/Auth/AuthField";
import Button from "../../ui/Button";
import a from "../../Clinic/Auth/auth.module.css";

export default function OwnerResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [step, setStep] = useState(1);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const token = decodeURIComponent(params.get("token") || "").trim();
  const email = decodeURIComponent(params.get("email") || "").trim().toLowerCase();

  const next = (e) => {
    e.preventDefault();
    if (password.length < 8) {
      setErr("Минимум 8 символов");
      return;
    }
    if (password !== confirm) {
      setErr("Пароли не совпадают");
      return;
    }
    setErr("");
    setStep(2);
  };

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await authAPI.resetOwnerPassword(token, email, password);
      if (r.result === 0) {
        navigate("/account/login", { replace: true });
      } else {
        setErr(r.error || r.message || "Ошибка");
        setStep(1);
      }
    } catch (error) {
      setErr(getApiErrorMessage(error, "Ошибка"));
      setStep(1);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PlatformAuthShell
      backTo="/account/login"
      backLabel="К входу"
      title="Новый пароль"
      subtitle="Задайте новый пароль для кабинета владельца — минимум 8 символов."
      stepCurrent={step}
      stepTotal={2}
      stepLabels={["Пароль", "Готово"]}
    >
      {err ? <div className={a.errorBox}>{err}</div> : null}

      {step === 1 ? (
        <form onSubmit={next}>
          <AuthField
            label="Пароль"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={8}
            required
          />
          <AuthField
            label="Повтор"
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            minLength={8}
            required
          />
          <div className={a.actions}>
            <Button type="submit" block size="lg" disabled={!token || !email}>
              Сохранить
            </Button>
          </div>
        </form>
      ) : (
        <form onSubmit={submit}>
          <div className={a.actions}>
            <Button type="submit" block size="lg" disabled={loading}>
              {loading ? "Сохранение…" : "Подтвердить"}
            </Button>
            <Button
              type="button"
              variant="ghost"
              block
              onClick={() => setStep(1)}
              disabled={loading}
            >
              Назад
            </Button>
          </div>
        </form>
      )}
    </PlatformAuthShell>
  );
}
